var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rightSidebarComponent && _vm.rightSidebarComponent.length > 0)?_c('keep-alive',[_c(_vm.rightSidebarComponent,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }